module.exports = __webpack_public_path__ + "static/ceo-3062129765d28e988701b3a299725900.mp4";